import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.nl';
import moment from 'moment';

class Publication {
	constructor(config) {

		this.config = Object.assign({
			scope: '.publication.page'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {

		this.$scope.on('click', '#location-other', function () {
			$('.publication-item').show();
			$(this).closest('.publication-item').hide();
		});

		this.$scope.on('click', '.words-format-switch', function () {
			let targetClass = $(this).data('target-class');
			$('.words-format-switch').toggle();
			$('.details').hide();
			$('.' + targetClass).show();
		});

		this.$scope.on('change', 'input[name=location]:not(#location-other)', this.locationChanged.bind(this));
		this.$scope.on('change', 'input[name=format_column], input[name=format_plane]', this.formatChanged.bind(this));
		this.$scope.on('change', 'input[name=column_height]', this.columnHeightChanged.bind(this));
		this.$scope.on('change', 'input[name=orientation]', this.orientationChanged.bind(this));
		this.$scope.on('change', 'input[name=color]', this.colorChanged.bind(this));
		this.$scope.on('click', '[data-scope="publication-sidebar"] .delete-placement', this.deletePlacement.bind(this));
		this.$scope.on('click', '[data-scope="publication-sidebar"] .selected-paper', this.switchPlacement.bind(this));
		this.$scope.on('click', 'button.duplicate-placement', this.duplicatePlacement.bind(this));
		this.initDatepickers();
	}

	formatChanged(e) {
		let name = $(e.currentTarget).attr('name');
		this.request({
			[name]: $(e.currentTarget).val()
		})
	}

	locationChanged(e) {
		this.request({
			'location': $(e.currentTarget).val()
		})
	}

	columnHeightChanged(e) {
		this.timeout ? clearTimeout(this.timeout) : '';
		this.timeout = setTimeout(() => {
			this.request({
				'column_height': $(e.currentTarget).val()
			});
		}, 200);
	}

	orientationChanged(e) {
		this.request({
			'orientation': $(e.currentTarget).val()
		})
	}

	colorChanged(e) {
		this.request({
			'color': $(e.currentTarget).val()
		})
	}

	publicationDateChanged(e) {
		let datePlacement = this.$scope.find('#placement').data('datepicker').getDate();
		let dateFormatted = moment(datePlacement).format('DD-MM-yyyy');
		this.request({
			'publication_date': dateFormatted
		})
	}

	async deletePlacement(event) {
		event.stopPropagation();
		event.cancelBubble = true;
		let uniqid = $(event.target).parents('[data-orderrow]:first').data('orderrow');
		let res = await $.delete('/uw-advertentie/publicatie-selectie/' + uniqid, function (data) {
			if (data.totalorderrows == 0) {
				location.href = "/krant-selecteren"
			} else {
				jQuery('[data-scope="publication-details"]').html(data.html);
				jQuery('[data-scope="publication-sidebar"]').html(data.summary);
				jQuery('[data-scope="price"]').html(data.price);
			}
		});
		event.stopPropagation()
		return false;
	}

	async switchPlacement(event) {
		let uniqid = $(event.target).parents('[data-orderrow]:first').data('orderrow');
		$(event.target).parents('[data-scope-]:first')
		let res = await $.get('/uw-advertentie/publicatie-selectie/' + uniqid, function (data) {
			jQuery('[data-scope="publication-details"]').html(data.html);
			jQuery('[data-scope="publication-sidebar"]').html(data.summary);
			jQuery('[data-scope="price"]').html(data.price);

		});
		this.initDatepickers();
	}

	async duplicatePlacement(event) {
		let uniqid = $(event.target).parents('[data-orderrow]:first').data('orderrow');
		$(event.target).parents('[data-scope-]:first')
		let res = await $.post('/uw-advertentie/publicatie-selectie/' + uniqid + '/duplicate', function (data) {
			jQuery('[data-scope="publication-details"]').html(data.html);
			jQuery('[data-scope="publication-sidebar"]').html(data.summary);
			jQuery('[data-scope="price"]').html(data.price);
		});
		this.initDatepickers();
	}

	async request(obj) {
		let uniqid = $('[data-scope="publication-details"]').find('[data-orderrow]:first').data('orderrow');
		let res = await $.post('/uw-advertentie/publicatie-selectie/' + uniqid + '/update', obj, function (data) {
			jQuery('[data-scope="publication-details"]').html(data.html);
			jQuery('[data-scope="publication-sidebar"]').html(data.summary);
			jQuery('[data-scope="price"]').html(data.price);

		});
		this.initDatepickers();
	}

	initDatepickers() {
		let enabledDates = this.$scope.find('#placement').data('enabled-dates').split(',');

		function formatDate(d) {
			var day = String(d.getDate())
			//add leading zero if day is is single digit
			if (day.length == 1)
				day = '0' + day
			var month = String((d.getMonth() + 1))
			//add leading zero if month is is single digit
			if (month.length == 1)
				month = '0' + month
			return day + "-" + month + "-" + d.getFullYear()
		}

		let datepickerConfig = {
			beforeShowDay: function (date) {
				if (enabledDates.indexOf(formatDate(date)) < 0)
					return {
						enabled: false
					}
				else
					return {
						enabled: true
					}
			},
			format: 'dd-mm-yyyy',
			inline: true,
			language: 'nl',
			multidate: false,
			calendarWeeks: true,
			weekHeader: 'Wk',
			maxViewMode: 0
		};

		this.$scope.find('#placement').datepicker({
			...datepickerConfig,
			startDate: moment().format('DD-MM-yyyy'),
		})

		this.$scope.find('#placement thead .cw').html('Wk');

		this.$scope.off('changeDate', '#placement');
		this.$scope.on('changeDate', '#placement', this.publicationDateChanged.bind(this));
	}

}

export default Publication;
